import { Effect, Layer } from "effect";
import { chatScrollFailure } from "./scroll-model.ts";
import { ChatScrollIo } from "./scroll-service.ts";

export const ChatScrollIoLive = Layer.succeed(ChatScrollIo, ChatScrollIo.of({
  measure: target => Effect.try({ try: () => ({ scrollHeight: target.scrollHeight, scrollTop: target.scrollTop, clientHeight: target.clientHeight }), catch: chatScrollFailure }),
  bottom: target => Effect.try({ try: () => { target.scrollTop = target.scrollHeight; }, catch: chatScrollFailure })
}));
